module.exports = __webpack_public_path__ + "static/work21-aa81277795becd18bfb532de1bffae94.jpg";